import React from 'react';
import Icon from './Icon';
import {IconProps} from './IconProps';


export default function IconSandClock({className, height, title}: IconProps) {
  return (
    <Icon className={className} height={height} title={title}>
      M16 2H14.75V6.60456C14.75 7.60418 14.2076 8.52508 13.3333 9.00973L11.3333 10.1184C11.2447 10.1675 11.1541 10.2114
      11.0619 10.25C11.1541 10.2886 11.2447 10.3325 11.3333 10.3816L13.3333 11.4903C14.2076 11.9749 14.75 12.8958 14.75
      13.8954V18.5H16V20H4V18.5H5.25V13.8954C5.25 12.8958 5.79243 11.9749 6.6667 11.4903L8.6667 10.3816C8.75528 10.3325
      8.8459 10.2886 8.93811 10.25C8.8459 10.2114 8.75528 10.1675 8.6667 10.1184L6.6667 9.00973C5.79243 8.52507 5.25
      7.60418 5.25 6.60456V2H4V0.5H16V2ZM6.756 16.0275L6.75 16.0313V13.8954C6.75 13.4411 6.99656 13.0225 7.39396
      12.8022L9.39396 11.6935C9.77096 11.4845 10.229 11.4845 10.606 11.6935L12.606 12.8022C13.0034 13.0225 13.25 13.4411
      13.25 13.8954V16.0313L13.244 16.0275L11.06 14.6625C10.4115 14.2572 9.58854 14.2572 8.94 14.6625L6.756
      16.0275ZM6.75 2H13.25V6.60456C13.25 6.74107 13.2277 6.87436 13.1858 7H6.81417C6.77226 6.87435 6.75 6.74107 6.75
      6.60456V2Z
    </Icon>
  );
}
